/* global SOLVNET */
(function($) {
"use strict";
	$.fn.materialPopinNPS = function(survey, onclose) {
		const div = $(this);

		const template = $(''
			+ '<form method="POST" action="" class="nps-form">'
			+ '    <div class="nps-error-message">' + SOLVNET.getLang('NPSSendingErrorMessage') + '</div>'
			+ '    <div class="form-group">'
			+ '        <label for="score" class="title required" data-error-message="' + SOLVNET.getLang('NPSRequiredField') + '">' + SOLVNET.getLang('NPSScoreLabel') + '&nbsp;</label>'
			+ '        <input id="score" name="score" type="hidden" min="0" max="10" step="1" required="true" class="form-control">'
			+ '        <div class="nps-score-range">'
			+ '            <div>'
			+ '                <span class="nps-score nps-score-bad">0</span>'
			+ '                <span class="nps-score nps-score-bad">1</span>'
			+ '                <span class="nps-score nps-score-bad">2</span>'
			+ '                <span class="nps-score nps-score-bad">3</span>'
			+ '                <span class="nps-score nps-score-bad">4</span>'
			+ '                <span class="nps-score nps-score-bad">5</span>'
			+ '                <span class="nps-score nps-score-bad">6</span>'
			+ '            </div>'
			+ '            <div>'
			+ '                <span class="nps-score nps-score-medium">7</span>'
			+ '                <span class="nps-score nps-score-medium">8</span>'
			+ '                <span class="nps-score nps-score-good">9</span>'
			+ '                <span class="nps-score nps-score-good">10</span>'
			+ '            </div>'
			+ '        </div>'
			+ '    </div>'
			+ '    <div class="form-group">'
			+ '         <label for="score" class="title">' + SOLVNET.getLang('NPSCommentLabel') + '</label>'
			+ '         <textarea id="comment" name="comment" class="form-control"></textarea>'
			+ '    </div>'
			+ '    <div class="title">' + SOLVNET.getLang('NPSCanBePublicTitle') + '</div>'
			+ '    <div>' + SOLVNET.getLang('NPSCanBePublicDescription') + '</div>'
			+ '    <div class="checkbox">'
			+ '        <label>'
			+ '             <input id="canBePublic" name="canBePublic" type="checkbox">'
			+ '        ' + SOLVNET.getLang('NPSCanBePublicLabel')
			+ '        </label>'
			+ '    </div>'
			+ '    <div class="nps-form-buttons-bar">'
			+ '        <button id="nps-postpone-btn" class="button btn btn-primary">' + SOLVNET.getLang('NPSPostponeButtonLabel') + '</button>'
			+ '        <button id="nps-send-btn" class="button btn btn-green-nomadia">' + SOLVNET.getLang('NPSSendButtonLabel') + '</button>'
			+ '    </div>'
			+ '</form>'
		).appendTo(div);

		const scoreElement = template.find('#score');
		const commentElement = template.find('#comment');
		const canBePublicElement = template.find('#canBePublic');
		const sendButton = template.find('#nps-send-btn');
		const postponeButton = template.find('#nps-postpone-btn');

		const scoreButtons = template.find('.nps-score');
		scoreButtons.click(event => {
			scoreButtons.removeClass('selected');
			const selectedScoreElement = $(event.target);
			selectedScoreElement.addClass('selected');
			scoreElement.val(parseInt(selectedScoreElement.text()));
		});

		function sendResponse(status, score, comment, canBePublic) {
			$.post(SOLVNET.getURL('nps'), {
				surveyId: survey.id,
				score: score,
				comment: comment,
				canBePublic: canBePublic,
				status: status
			}).done(() => {
				close();
			}).fail(() => {
				template.find('.nps-error-message').show();
				// En cas d'erreur on ferme la popup sauf si l'utilisateur essayait d'envoyer sa réponse pour ne pas le bloquer
				if (status !== 'COMPLETED')
					close();
			});
		}

		function close() {
			div.closest('.bbm-overlay-background').remove(); // Fermeture de la popup
			if (onclose)
				onclose();
		}

		sendButton.click(event => {
			event.preventDefault();
			const score = scoreElement.val();
			const comment = commentElement.val();
			const canBePublic = !canBePublicElement.is(':checked');
			if (!score || score === '') {
				template.find('.title.required').addClass('show-error');
			}
			else
				sendResponse('COMPLETED', score, comment, canBePublic);
		});
		postponeButton.click(event => {
			event.preventDefault();
			sendResponse('POSTPONED');
		});
		div.overlayFitContent(survey.name, () => sendResponse('CANCELED'));
		
	};

})(window.jQuery);